import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Box, Typography } from '@mui/material'

import { AnnouncementDate, CallToAction, UnreadDot } from './AnnouncementParts'
import { useLocalizedText } from '../../domain/announcements'

const AnnouncementRow = ({ announcement, onOpen, onFollow }) => {
  const localize = useLocalizedText()
  const thumbnail = announcement.pictures[0]

  return (
    <Box
      role="button"
      tabIndex={0}
      aria-label={localize(announcement.title_i18n)}
      onClick={onOpen}
      onKeyDown={(event) => event.key === 'Enter' && onOpen()}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.5,
        cursor: 'pointer',
        '&:hover, &:focus-visible': { bgcolor: 'action.hover', outline: 'none' },
        '&:hover .title, &:focus-visible .title': { color: 'primary.main' },
        '&:hover .chevron, &:focus-visible .chevron': { transform: 'translateX(3px)', color: 'text.primary' },
      }}
    >
      <UnreadDot unread={announcement.unread} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <AnnouncementDate announcement={announcement} />
        <Typography
          className="title"
          variant="body1"
          sx={{ fontWeight: announcement.unread ? 600 : 400, lineHeight: 1.35, transition: 'color .15s' }}
        >
          {localize(announcement.title_i18n)}
        </Typography>
        <CallToAction announcement={announcement} onFollow={onFollow} size="small" sx={{ mt: 0.5, ml: -1 }} />
      </Box>
      {thumbnail && (
        <Box
          component="img"
          src={thumbnail.url}
          alt=""
          sx={{
            width: 72,
            height: 46,
            flexShrink: 0,
            objectFit: 'cover',
            borderRadius: 1,
            border: 1,
            borderColor: 'divider',
          }}
        />
      )}
      <ChevronRightIcon
        className="chevron"
        fontSize="small"
        sx={{ color: 'text.disabled', flexShrink: 0, transition: 'transform .15s, color .15s' }}
      />
    </Box>
  )
}

export default AnnouncementRow
